
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'


export default {
name: 'secondBdEdit',
components: {
XTextarea,Group
},
data() {
return {
formData:{
id:0,
name:'',
phone:'',
account:'',
password:'',
content:''
},
}
},
created() {
this.formData.id = Number(this.$route.params.id);
console.log(this.formData);
if(this.formData.id > 0){
this.getSecondBd();
}
},
computed:{

},
methods: {
getSecondBd() {
this.$api.getSecondBd({id:this.formData.id}).then((res)=>{
if(res){
this.formData = res.data;
}
})
},
submit() {
if(!this.formData.name){
this.$func.showToast('请输入姓名或名称');
return false;
}
if(!this.formData.phone){
this.$func.showToast('请输入手机号');
return false;
}
if(!this.formData.account){
this.$func.showToast('请输入登录账号');
return false;
}
if(!this.formData.password){
this.$func.showToast('请输入登录密码');
return false;
}
this.$api.submitSecondBd(this.formData).then((res)=>{
if(res){
this.$func.showToast('提交成功');
setTimeout(()=>{
this.$router.go(-1);
},300)
}
});
},
}
}



// WEBPACK FOOTER //
// ./src/pages/secondBdEdit.vue